module.exports = "https://static-www.niulinkcloud.com/_next/static/media/qq.59df3f0ad8ec221b09a147cd244642c4.png";